// extracted by mini-css-extract-plugin
module.exports = {"navlinks":"NavLinks_navlinks__1HVPn","mobileLinks":"NavLinks_mobileLinks__39UK1","active":"NavLinks_active__3390U","logoutBtn":"NavLinks_logoutBtn__38yFB"};